import T from 'prop-types';
import { compose, createParser, system } from './styled-system';
import { unit } from './unit';
export { compose, system };

function isNumber(num) {
  // eslint-disable-next-line no-restricted-globals
  return typeof num === 'number' && !isNaN(num);
}

function transformValue(value) {
  if (isNumber(value)) {
    return value === 0 ? 0 : unit(value);
  }

  return value;
} // PropTypes


const propType = T.oneOfType([T.number, T.string, T.arrayOf(T.oneOfType([T.number, T.string]))]);
export function createPropTypes(props) {
  return props.reduce((acc, name) => {
    acc[name] = propType;
    return acc;
  }, {});
} // Variant

export const variant = (variants, prop = 'variant') => {
  const sx = (value, scale) => (scale === null || scale === void 0 ? void 0 : scale[value]) || null;

  sx.defaults = variants;
  const config = {
    [prop]: sx
  };
  const parser = createParser(config);
  return parser;
}; // Background

export const background = system({
  bg: {
    property: 'background'
  }
}); // Text

export const textAlign = system({
  textAlign: true
});
export const textColor = system({
  textColor: {
    property: 'color'
  }
}); // Layout

export const layout = system({
  height: {
    property: 'height',
    transform: transformValue
  },
  width: {
    property: 'width',
    transform: transformValue
  },
  maxHeight: {
    property: 'maxHeight',
    transform: transformValue
  },
  maxWidth: {
    property: 'maxWidth',
    transform: transformValue
  },
  minHeight: {
    property: 'minHeight',
    transform: transformValue
  },
  minWidth: {
    property: 'minWidth',
    transform: transformValue
  },
  size: {
    properties: ['width', 'height'],
    transform: transformValue
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
}); // Flexbox

export const flexbox = system({
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
}); // Spacing

const marginConfig = {
  m: {
    property: 'margin',
    transform: transformValue
  },
  mt: {
    property: 'marginTop',
    transform: transformValue
  },
  mr: {
    property: 'marginRight',
    transform: transformValue
  },
  mb: {
    property: 'marginBottom',
    transform: transformValue
  },
  ml: {
    property: 'marginLeft',
    transform: transformValue
  },
  mx: {
    properties: ['marginLeft', 'marginRight'],
    transform: transformValue
  },
  my: {
    properties: ['marginTop', 'marginBottom'],
    transform: transformValue
  }
};
const paddingConfig = {
  p: {
    property: 'padding',
    transform: transformValue
  },
  pt: {
    property: 'paddingTop',
    transform: transformValue
  },
  pr: {
    property: 'paddingRight',
    transform: transformValue
  },
  pb: {
    property: 'paddingBottom',
    transform: transformValue
  },
  pl: {
    property: 'paddingLeft',
    transform: transformValue
  },
  px: {
    properties: ['paddingLeft', 'paddingRight'],
    transform: transformValue
  },
  py: {
    properties: ['paddingTop', 'paddingBottom'],
    transform: transformValue
  }
};
export const margin = system(marginConfig);
export const padding = system(paddingConfig);
export const space = system(Object.assign({}, marginConfig, paddingConfig));